// @flow

import { RECEIVED_CONTACT_SETTINGS, RECEIVED_CONTACT_LABEL_SETTINGS } from './constants';
import type {
  LabelContactSettings,
  ReceivedLabelContactSettings,
  ContactSettings,
} from './types';

export type ReceivedContactSettings = {|
  type: typeof RECEIVED_CONTACT_SETTINGS,
  payload: ContactSettings,
|};

export type ReceivedContactLabelSettings = {|
  type: typeof RECEIVED_CONTACT_LABEL_SETTINGS,
  label: string,
  payload: ReceivedLabelContactSettings,
|};

export const receivedContactSettings = (data: ContactSettings): ReceivedContactSettings => ({
  type: RECEIVED_CONTACT_SETTINGS,
  payload: data,
});

export const receivedContactLabelSettings = (
  label: string,
  data: LabelContactSettings,
): ReceivedContactLabelSettings => ({
  type: RECEIVED_CONTACT_LABEL_SETTINGS,
  label,
  payload: {
    general_number: data.telephone,
    general_email_address: data.email,
    street: data.address.street,
    postal_code: data.address.postal_code,
    city: data.address.city,
    address: data.address,
  },
});

export default null;
